import AccessoriesA from './components/AccessoriesA';
import Animation3D from './components/Animation3D';
import Animation2 from './components/Animation2';
import BannerB from './components/BannerB';
import BlackA from './components/BlackA';
import ListA2 from './components/ListA2';
import CompareA from './components/CompareA';
import FaqA from './components/FaqA';
import FooterTcA from './components/FooterTcA';
import ListA1 from './components/ListA1';
import ListB from './components/ListB';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import SectionA3 from './components/SectionA3';
import SectionB from './components/SectionB';
import SectionC from './components/SectionC';
import SectionD from './components/SectionD';
import SectionE from './components/SectionE';
import WhatInBoxA from './components/WhatInBoxA';
import { useLang } from '@/i18n';
import { useShoppingCart } from '../../useShoppingCart';

export default function JP_Product() {
    const { t } = useLang('theProduct.KSP');

    const { Comp, handleAddCart } = useShoppingCart();

    return (
        <div className="ecoflow-wave-3-page">
            <BannerB />
            <ListB />
            <div className="range1">
                <ListA1 />
            </div>
            <SectionA3 />
            <div className="range2">
                <Animation2 />
            </div>
            <div className="range3">
                <SectionB />
            </div>
            <div className="range4">
                <FaqA />
            </div>
            <div className="range5">
                <BlackA />
            </div>
            <ListA2 />
            <div className="range6">
                <SectionD />
            </div>
            <SectionC />
            <SectionE />
            <Animation3D />
            <CompareA />
            <WhatInBoxA />
            <AccessoriesA callback={handleAddCart} />
            <FooterTcA />

            <PageNavLeft
                triggerElement=".ecoflow-wave-3-page"
                enterElement="#ListB"
                steps={[
                    { text: t('item1'), href: '#ListA1' },
                    { text: t('item2'), href: '#wave3-D' },
                    { text: t('item3'), href: '#SectionB' },
                    { text: t('item4'), href: '#FaqA' },
                    { text: t('item5'), href: '#BlackA' },
                    { text: t('item6'), href: '#SectionD' },
                ]}
                triggerElements={[
                    { selectors: '#ListA1', theme: Theme.black },
                    { selectors: '#sectionC1', theme: Theme.white },
                    { selectors: '#screen1', theme: Theme.black },
                    { selectors: '#FaqA', theme: Theme.black },
                    { selectors: '#BlackA', theme: Theme.white },
                    { selectors: '#ListA2', theme: Theme.white },
                    { selectors: '#SectionD', theme: Theme.black },
                ]}
            />

            {Comp}
        </div>
    );
}
